const PROCESO_GERENTE_SOLICITANTE = '07';
const PROCESO_GERENTE_APROBADOR = '08';

export const ProcesoHelper = {
    PROCESO_GERENTE_SOLICITANTE,
    PROCESO_GERENTE_APROBADOR
};